import { render, staticRenderFns } from "./NewPaymentsTableMobile.vue?vue&type=template&id=4901142e&scoped=true"
import script from "./NewPaymentsTableMobile.vue?vue&type=script&lang=js"
export * from "./NewPaymentsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4901142e",
  null
  
)

export default component.exports